import React from 'react'

const Italic = ({ text, textSize = '12' }) => {
  return (
    <i className='clr-lgt-grey' style={{ fontSize: `${textSize}px` }}> {text} </i>
  )
}

export default Italic
